export default function (instance) {
  instance.globalCache = {
    isWorkDays: {},
  };

  instance.clearCache = function (key) {
    instance.globalCache[key] = {};
  };
}
